import React from 'react';
import { v4 as uuid } from 'uuid';
import { sleep } from '../helpers/sleep';

class Component extends React.Component {
    constructor() {
        super();

        this.forceRun = this.forceRun.bind(this);
        this.callQuery = this.callQuery.bind(this);
        this.checkMaxMin = this.checkMaxMin.bind(this);
        this.handleMoodeChange = this.handleMoodeChange.bind(this);
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));

        this.state = {
            loading: true,
            isDark: !!isDark,
        };
    }

    async callQuery() {
        this.query.bind(this.setState.bind(this));
        const results = await this.query.update();
        const data = results?.map((x) => ({ id: uuid(), ...x }));
        this.setState({
            data,
        });
    }

    async checkMaxMin() {
        if (!window.waitMinMax) return this.callQuery();

        if (!window.minMaxDates) {
            await sleep(1000);
            return this.checkMaxMin();
        }

        this.callQuery();
    }

    async componentDidMount() {
        document.addEventListener('changeMoodEvent', this.handleMoodeChange);
        if (this.query) {
            await sleep(0);
            this.checkMaxMin();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    handleMoodeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ isDark });
    }

    forceRun() {
        if (this.query) this.query.update({ force: true, alreadyInQueue: true });
    }
}

export default Component;
